const API_BASE_URL = (import.meta.env.VITE_API_BASE_URL || "").replace(
  /\/$/,
  "",
);

export function apiUrl(path) {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${API_BASE_URL}${normalizedPath}`;
}

export async function apiFetch(path, options) {
  const method = (options?.method || "GET").toUpperCase();
  const headers = new Headers(options?.headers);
  if (!["GET", "HEAD", "OPTIONS"].includes(method))
    headers.set("X-Requested-With", "PermitPilot");
  const res = await fetch(apiUrl(path), {
    credentials: "include",
    ...options,
    ...(Array.from(headers.keys()).length ? { headers } : {}),
  });

  return res;
}

/**
 * Safely parse a response as JSON, handling cases where the server
 * returns HTML error pages (e.g. CloudFront 504) instead of JSON.
 */
export async function safeJson(res) {
  const text = await res.text();
  try {
    return JSON.parse(text);
  } catch {
    // CloudFront/ALB returned an HTML error page
    if (text.includes("504 Gateway Timeout") || text.includes("Gateway Time")) {
      throw new Error(
        "Request timed out. Your route is still processing — please wait and try again in a moment.",
      );
    }
    if (text.includes("502 Bad Gateway")) {
      throw new Error(
        "Server is temporarily unavailable. Please try again in a minute.",
      );
    }
    if (text.includes("503")) {
      throw new Error(
        "Service is temporarily busy. Please wait a moment and try again.",
      );
    }
    throw new Error(
      "Server returned an unexpected response. Please try again.",
    );
  }
}
